exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inline-button[data-v-dcff280e] {\n  display: inline-block;\n}\n", ""]);

// exports
